/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import { RefObject } from "react";

import { Displayer, RequiredAsterisk } from "@smart/itops-sb-design-system-dom";

import { SectionErrors, sectionFallback, SectionItem } from "../../types";
import { ErrorSummary } from "../shared-components/error-summary";

export type SectionHeadingProps = {
  section: SectionItem;
  errorsRef?: RefObject<HTMLDivElement>;
  errors?: SectionErrors;
  hideErrors?: boolean;
};

export const SectionHeading = ({
  section: { title, description, hasRequired },
  errorsRef,
  errors,
  hideErrors,
}: SectionHeadingProps) => (
  <div className="[&>h1]:text-h2 [&>h1]:font-semibold [&>h1]:font-poppins [&>p]:text-ui [&>p]:font-semibold">
    <Displayer paragraphTag="h1" value={title} fallback={sectionFallback} />
    <Displayer value={description} />
    {hasRequired && (
      <p>
        <small className="text-caption text-neutral-600 font-normal">
          <RequiredAsterisk className="mx-0" /> indicates required information
        </small>
      </p>
    )}
    {errors && errors.total > 1 && !hideErrors && (
      <ErrorSummary errors={errors.errors} errorsRef={errorsRef} />
    )}
  </div>
);
